var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-word_svg__a",
    x1: "17.372%",
    x2: "82.628%",
    y1: "-6.51%",
    y2: "106.51%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1146AC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M22.968.8H6.602c-.565 0-1.023.458-1.023 1.023v4.556l9.485 2.79 8.926-2.79V1.823c0-.565-.457-1.023-1.022-1.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M23.99 6.379H5.579v5.579l9.485 1.674 8.926-1.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M5.579 11.958v5.58l8.927 1.115 9.484-1.115v-5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M6.602 23.117h16.366c.565 0 1.022-.458 1.022-1.023v-4.556H5.58v4.556c0 .565.457 1.023 1.022 1.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.367 5.263H5.58v13.948h6.788a1.026 1.026 0 001.023-1.022V6.286a1.027 1.027 0 00-1.023-1.023z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.81 5.821H5.58V19.77h6.23a1.026 1.026 0 001.022-1.022V6.844a1.027 1.027 0 00-1.023-1.023z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.81 5.821H5.58v12.832h6.23a1.025 1.025 0 001.022-1.022V6.844a1.027 1.027 0 00-1.023-1.023z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.252 5.821H5.579v12.832h5.673a1.024 1.024 0 001.022-1.022V6.844a1.027 1.027 0 00-1.022-1.023z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#app-word_svg__a)",
    d: "M1.023 5.021h10.229c.564 0 1.022.458 1.022 1.023v10.229c0 .565-.458 1.022-1.022 1.022H1.022A1.023 1.023 0 010 16.273V6.043c0-.564.458-1.022 1.023-1.022z",
    transform: "translate(0 .8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.197 13.664c.02.158.033.296.04.413h.023c.009-.111.027-.246.055-.403.029-.157.054-.29.077-.399l1.076-4.64h1.39l1.116 4.57c.065.285.112.573.14.863h.018c.02-.281.06-.56.116-.837l.89-4.599h1.265l-1.563 6.65H7.361l-1.06-4.404a10.332 10.332 0 01-.176-.942h-.019a9.365 9.365 0 01-.072.482c-.035.213-.064.37-.085.473l-.997 4.39H3.448L1.876 8.634h1.29l.968 4.65c.022.096.043.223.063.38z"
  })))));
}

export default SvgAppWord;